import { FolderSharingSettingKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetFolderSharingSettingRequest, GetFolderSharingSettingResponse } from "@maven-rest/docs/FolderSharingSetting.dto";
import { FolderSharingSettingUrl } from "@maven-rest/docs/FolderSharingSetting.url";

export function useFolderSharingSettingQuery(
  req: GetFolderSharingSettingRequest,
  options?: SimpleQueryOptions<GetFolderSharingSettingResponse, GetFolderSharingSettingRequest>
) {
  return useBaseQuery({
    queryKey: [FolderSharingSettingKey.FolderSharingSetting, req.organizationId, req.folderId, req.fileId],
    fnOption: {
      url: FolderSharingSettingUrl.getFolderSharingSetting,
      request: req,
    },
    ...options,
  });
}
